import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import React from "react";


// const useStyles = makeStyles((theme: Theme) =>
//   createStyles({
//     root: {},
//     files: {
//       marginTop: theme.spacing(3),
//     },
//   })
// );

type ErrorDialogProps = {
  open: boolean;
  onSubmit: () => void;
};
const ErrorDialog: React.FC<ErrorDialogProps> = ({ open, onSubmit }) => {
  const handleSubmit = () => {
    // setOpen(false);
    onSubmit();
  };

  const handleClose = () => {
    // setOpen(false);
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Session Timeout?"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Your session has been expired, Please login again to continue.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="secondary" onClick={onSubmit}>
            Login Again
          </Button>
          {/*<SBButton icon={false} text={"Login"} onClick={handleSubmit} />*/}
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ErrorDialog;
